<template>  
  <kst-section :title="sectionTitle">
    <kst-output field="DeliveryAddress" :data="data" :catalog="Catalog"/>
    <kst-output field="DeliveryDate" :data="data" :catalog="Catalog"/>
  </kst-section>
</template>

<script>
import Catalog from "../PurCatalog.js";
import Info from "../PurInfo.js";

export default {
  props: {
    data: Object
  },
  data: () => ({
    Catalog: Catalog
  }),
  computed: {
    sectionTitle() {
      return Info.Section.Delivery.Title;
    }
  }
}
</script>